import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { UpdateLifetimeAllowanceDispatcher } from "./Variable";


export interface UpdateLifetimeAllowanceState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
    lifetimeAllowanceOffPlatform?: number;
    offPlatformData?: any;
}

export class UpdateLifetimeAllowanceStatic extends BaseStore<UpdateLifetimeAllowanceState> {
    constructor() {
        super();
        this.subscribeToDispatcher(UpdateLifetimeAllowanceDispatcher, (actionData) => this.onUpdateLifetimeAllowanceStoreResponse(actionData));
    }

    public getLastResult(): UpdateLifetimeAllowanceState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getLifetimeAllowanceOffPlatform() {
        return this.getState().lifetimeAllowanceOffPlatform;
    }
   
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): UpdateLifetimeAllowanceState {
        return { actionType: ActionType.Loading, data: null, };
    }

    private onUpdateLifetimeAllowanceStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, lifetimeAllowanceOffPlatform: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
